import { useContext, useEffect } from "react";
import AuthContext from "../../context/AuthProvider";
import Post from "../../components/Social/Post";
import PushPrompt from "../../components/PushPrompt";
import MonthlyCalendar from "../../components/Calendar/MonthlyCalendar";
import { formatDate } from "../../components/Social/Ekloges";
import usePostsFeed from "../../features/home/usePostsFeed";
import {
  usePostViewCounter,
  useReport,
  useSmallCalendar,
} from "../../features/home/useHomeWidgets";
import PostComposer from "./PostComposer";
import { CalendarSyncCard, ReportCard, UpcomingDatesCard } from "./HomeSideCards";
import "./home.css";

// Desktop home: the feed in the middle (composer on top), calendar and
// shortcuts on the right; each column scrolls on its own.
const HomeDesktop = () => {
  const { avatarUploaded } = useContext(AuthContext);
  const { posts, loading, hasMore, sentryRef, reloadNewest, deletePost } = usePostsFeed();
  const { dates, calUuid } = useSmallCalendar();
  const report = useReport();
  usePostViewCounter();

  useEffect(() => {
    document.title = "MySolon.gr";
  }, []);

  return (
    <div className="ds-home">
      <div className="ds-home-feed">
        <div className="ds-home-feed-inner">
          <PushPrompt />
          <PostComposer onPosted={reloadNewest} />
          {loading && posts.length === 0 && (
            <div className="ds-empty">
              <span className="ds-spinner" aria-hidden="true" /> Φόρτωση αναρτήσεων…
            </div>
          )}
          {posts.map((post) => (
            <div className="ds-home-post" key={post.uuid}>
              <Post
                creator={`${post.user?.first_name} ${post.user?.last_name}`}
                email={post.user?.email}
                timeSince={formatDate(post?.created_at)}
                body={post.body}
                postUuid={post.uuid}
                avatar={post.user?.avatar_uuid}
                uuid={post.user?.uuid}
                avatarUploaded={avatarUploaded}
                postCreatorId={post.user?.id}
                deletePost={deletePost}
                grammateas={post.grammateas}
                post={post}
                getPosts={reloadNewest}
              />
            </div>
          ))}
          {hasMore && (
            // Remounted per page so the observer fires again if still visible.
            <div key={posts.length} ref={sentryRef} className="ds-empty ds-home-sentry">
              <span className="ds-spinner" aria-hidden="true" /> Φόρτωση…
            </div>
          )}
        </div>
      </div>

      <aside className="ds-home-side" aria-label="Ημερολόγιο και εργαλεία">
        <section className="ds-card ds-home-calendar">
          <MonthlyCalendar dates={dates} />
        </section>
        <UpcomingDatesCard dates={dates} />
        <CalendarSyncCard calUuid={calUuid} />
        <ReportCard
          reportUUID={report.reportUUID}
          reportLoading={report.reportLoading}
          onCreate={report.createReport}
        />
        <a
          className="ds-card ds-card-link ds-home-5221"
          href="https://5221.mysolon.gr"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ν. 5221/2025 – Ανάλυση Μεταρρυθμίσεων ΚΠολΔ →
        </a>
      </aside>
    </div>
  );
};

export default HomeDesktop;
